export default "__VITE_ASSET__D7ai_wn$__"